import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { WhatIsEbook } from './components/WhatIsEbook';
import { Problem } from './components/Problem';
import { Revelation } from './components/Revelation';
import { Benefits } from './components/Benefits';
import { BookDescription } from './components/BookDescription';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { WhatYouGet } from './components/WhatYouGet';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '401851746104415';
export function App() {
  // Meta Pixel install — inlined here (no separate lib file) because Magic
  // Patterns ignores index.html / src/index.tsx, so any pixel code outside
  // the React component tree never reaches production.
  useEffect(() => {
    try {
      const w = window as unknown as {
        fbq?: ((...args: unknown[]) => void) & {
          callMethod?: (...args: unknown[]) => void;
          queue?: unknown[];
          push?: unknown;
          loaded?: boolean;
          version?: string;
        };
        _fbq?: unknown;
      };

      // If something else (or a previous mount) already loaded fbq, just
      // fire PageView and bail — the snippet is idempotent.
      if (typeof w.fbq === 'function') {
        w.fbq('track', 'PageView');
        return;
      }

      // Standard Meta Pixel base snippet, written out longhand.
      const fbq = function (this: unknown) {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args as unknown as unknown[]);
        } else {
          (fbq.queue as unknown[]).push(args);
        }
      } as ((...args: unknown[]) => void) & {
        callMethod?: (...args: unknown[]) => void;
        queue: unknown[];
        push: unknown;
        loaded: boolean;
        version: string;
      };
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      // Append to head/body/documentElement — at least one is always
      // present, including in Magic Patterns' sandboxed editor preview
      // (where document.getElementsByTagName('script')[0] can be undefined).
      const host = document.head || document.body || document.documentElement;
      host?.appendChild(script);
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (err) {
      // Pixel failure must never crash the app render.
      console.warn('[fbpixel] init failed:', err);
    }
  }, []);
  return <div className="min-h-screen bg-matrix-black text-matrix-white font-inter selection:bg-matrix-green selection:text-matrix-black" data-id="element-0">
      <Hero data-id="element-1" />
      <WhatIsEbook data-id="element-2" />
      <Problem data-id="element-3" />
      <Revelation data-id="element-4" />
      <Benefits data-id="element-5" />
      <BookDescription data-id="element-6" />
      <Testimonials data-id="element-7" />
      <CTA data-id="element-8" />
      <WhatYouGet data-id="element-9" />
      <PricingCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}